import { PoGrid } from '@/components/grid/PoGrid';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router';
import ErrorLoadingDataAlert from '@/components/feedback/ErrorLoadingDataAlert';
import { ColDefOrGroup } from '@/lib/ag-grid/types';
import { AssetModel } from '@/modules/assets/types/AssetModel';
import { GridOptions, RowDoubleClickedEvent, ValueGetterParams } from 'ag-grid-community';
import { useTranslation } from '@/lib';
import { ColumnID } from '@/components/grid/column-ids';
import { PeriodInDaysCellRenderer } from '@/components/grid/cells/PeriodInDaysCellRenderer';

interface LocationAssetsGridProps {
  data?: AssetModel[];
  isError: boolean;
}

export const LocationAssetsGrid: FunctionComponent<LocationAssetsGridProps> = ({ data, isError }) => {
  const { t } = useTranslation();
  if (!data) {
    return <div>{t('no_data')}</div>;
  }
  const navigate = useNavigate();

  const customGridOptions: GridOptions<AssetModel> = {
    onRowDoubleClicked(asset: RowDoubleClickedEvent<AssetModel, unknown>) {
      navigate(`/app/assets/${asset.data?.id}`);
    },
  };

  const columns: ColDefOrGroup<AssetModel>[] = [
    {
      colId: ColumnID.ASSET_TYPE_NAME,
      headerName: t('type'),
      valueGetter: (params: ValueGetterParams<AssetModel>) => {
        return params.data?.assetType.name;
      },
    },
    {
      colId: ColumnID.ASSET_CODE,
      field: 'code',
      headerName: t('code'),
    },
    {
      colId: ColumnID.STAYTIME,
      field: 'locationEnteredDate',
      headerName: t('stay_time'),
      cellRenderer: PeriodInDaysCellRenderer,
      valueFormatter: (params) => (params.value ? new Date(params.value).toISOString() : ''),
    },
  ];

  return (
    <div className="flex h-full flex-1 grow flex-col">
      {isError ? <ErrorLoadingDataAlert /> : <PoGrid isLoading={false} colDefs={columns} rowData={data} gridOptions={customGridOptions} />}
    </div>
  );
};
